﻿import { ssApiService } from './ss-api.service';
import { Injectable } from '@angular/core';
import { TagArray } from '../models/domain/tag';
import { Subject } from 'rxjs/Subject';

import 'rxjs';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class TagService {

    // events
    public onAllPossibleTagsLoaded = new Subject<TagArray>();

    // vars
    AllPossibleTags: TagArray;



    constructor(private ssdb2: ssApiService) {

    }

    LoadAllPossibleTags(): void {

        let tagSubscriptions = this.ssdb2.getAvailableTags().subscribe(
            response => {
                tagSubscriptions.unsubscribe();
                this.AllPossibleTags = response.Data;
                this.onAllPossibleTagsLoaded.next(response.Data);
            })

    }


    FilterAllPossibleMemberTags(): TagArray {

        if (!this.AllPossibleTags)
            return new TagArray();

        let result = new TagArray();
        this.AllPossibleTags.forEach((tag) => {
            if (tag.forMember)
                result.push(tag);
        })

        return result;
    }

}
